import { GetEBaseDataService } from './api-services/get-ebase-data.service';
import { GetEBaseNoService } from './api-services/get-ebase-no.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW1103Component } from './kymw1103.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { SharedModule } from '../../../shared/shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

/**
 * eBASE商品仕様反映データ選択画面 モジュール設定クラス
 *
 * @export KYMW1103Module
 * @class KYMW1103Module
 */
@NgModule({
  imports: [
    CommonModule,
    PlessSharedModule,
    SharedModule,
    AppCommonsModule,
    WjInputModule,
    WjNavModule,
    WjGridModule
  ],
  declarations: [
    KYMW1103Component,
  ],
  providers: [
    GetEBaseDataService,
    GetEBaseNoService
  ],

})
export class KYMW1103Module { }
